import { ImageLoaderCSSStyleImpl } from '../../../../../../ui/toolkit/imageloader/imageloadercss';

export class MyTonesCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '250px',
            borderRadius: "50px 0px 50px 0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonescardimageloader.tsx